import { Component, OnDestroy, OnInit, ViewChild, inject, signal } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DIALOG_RETURN_TYPES, DialogService } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { OfferOverviewModel } from 'src/app/dashboard/components/overview/models/overview.model';

import { AdvertisementsActiveOffersDataSource } from 'src/app/my-advertisements/datasources/active-offers-datasource/active-offers.datasource';
import { displayOfferColumns } from 'src/app/my-advertisements/models/overview-tables.model';
import { deleteOffer } from 'src/app/my-advertisements/store/actions/my-advertisements.actions';

@Component({
  selector: 'app-active-offers-overview-table',
  templateUrl: './active-offers-overview-table.component.html',
  styleUrls: ['./active-offers-overview-table.component.scss'],
  standalone: false,
})
export class ActiveOffersOverviewTableComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly localeService = inject(LocaleService);
  private readonly dialogService = inject(DialogService);

  readonly dataSource = new AdvertisementsActiveOffersDataSource(this.store, this.actions$);
  readonly displayColumns = displayOfferColumns;
  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );
  readonly destroy$ = new Subject<void>();
  selectedCustomerId = signal<number | undefined>(undefined);

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<OfferOverviewModel[]>;

  ngOnInit(): void {
    this.selectedCustomer$.pipe(takeUntil(this.destroy$)).subscribe((customer) => {
      if (customer) {
        this.selectedCustomerId.set(customer.id);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  deleteOffer(offer: OfferOverviewModel) {
    this.dialogService
      .confirm({
        title: this.localeService.translate('my-dashboard.delete-confirmation-title'),
        text: this.localeService.translate('my-dashboard.delete-confirmation-message'),
        confirmButtonColor: 'primary',
        confirmButtonText: this.localeService.translate(
          'my-dashboard.delete-confirmation-confirm-text',
        ),
        cancelButtonText: this.localeService.translate(
          'my-dashboard.delete-confirmation-cancel-text',
        ),
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(deleteOffer({ id: offer.id }));
        }
      });
  }
}
